import { useState, useEffect } from 'react';
import { getServices } from '@breath-lab/services';

export type LayoutVariant = 'sidebar' | 'navbar';

export function useLayoutVariant(): LayoutVariant {
  const [variant, setVariant] = useState<LayoutVariant>('navbar');

  useEffect(() => {
    const rc = getServices().remoteConfig;
    rc.fetchAndActivate().then(() => {
      setVariant(rc.getBoolean('navbarLayoutEnabled') ? 'navbar' : 'sidebar');
    });
  }, []);

  return variant;
}
